export default __webpack_public_path__ + "static/media/no_content_point.ba1119ed.png";